module.exports = __webpack_public_path__ + "img/34.5044f729.jpg";